<app-dialog
  header="Укажите новый срок!"
  [styleClass]="'prolong-confirm-dialog ' + styleClass"
  [(visible)]="visible"
  (onHide)="onClose($event)"
  (onShow)="onOpen($event)"
  [minY]="minY"
  [closable]="closable"
  [style]="{ width: width }"
>
  <div class="form-row prolong-confirm-dialog-content">
    <span class="col-6 col-form-label"
      >Дата окончания действия предложения *</span
    >
    <div class="col-6 input-row">
      <app-prime-calendar
        [readonlyInput]="true"
        [locale]="inputSettings.calendar.locale"
        [dateFormat]="inputSettings.calendar.formats.short"
        [outputFormat]="inputSettings.calendar.outputFormats.iso"
        [showButtonBar]="true"
        styleClass="desc-wrapper__prime-calendar"
        [showIcon]="true"
        [minimumDate]="validityDateContraints.Minimum"
        [maximumDate]="validityDateContraints.Maximum"
        [(ngModel)]="validityDate"
        #newValidityDate="ngModel"
      >
      </app-prime-calendar>
    </div>
  </div>
  <app-validation-message
    [control]="newValidityDate"
    class="app-validation-message"
    validationMessage="Укажите дату окончания действия предложения"
  ></app-validation-message>
  <div footer>
    <button
      class="btn btn__white-with-shadow"
      (click)="onProlongDialogOkButtonClick($event)"
    >
      Ок
    </button>
    <button class="btn btn__white-with-shadow" (click)="onClose($event)">
      Отмена
    </button>
  </div>
</app-dialog>
